// extracted by mini-css-extract-plugin
module.exports = {"efbutton":"EFButton_efbutton__XyDxE","efbutton__primary":"EFButton_efbutton__primary__ajI2L"};